<template>
  <div class="pid-overwrite-form">
    <div class="pid-overwrite-form__header mt-2 mb-4">
      Select the quarters you wish to include/overwrite with your new PID list
    </div>
    <div class="table-body">
      <v-simple-table
        height="500px"
        dense
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" width="25%">
                Quarter
              </th>
              <th class="text-center" width="25%">
                Exists
              </th>
              <th class="text-center" width="25%">
                Include/Overwrite
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in data"
              :key="item.quarter"
            >
              <td>
                {{ item.quarter }}
              </td>
              <td>
                <div class="d-flex justify-center">
                  <v-checkbox disabled v-model="item.exists"></v-checkbox>
                </div>
              </td>
              <td>
                <div class="d-flex justify-center">
                  <v-checkbox v-model="item.override"></v-checkbox>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <action-button
      label="Process"
      @click.native="overwriteFiles"
      color="secondary"
      id="pidAppendProcessBtn"
    >
    </action-button>
  </div>
</template>

<script>
import ActionButton from '@/components/common/actionButton'
import { OVERWRITE_PID } from '@/appLogic/targets/createTarget/store/actions'

export default {
  components: {
    ActionButton
  },
  props: {
    overwrites: {
      type: Array,
      default: () => []
    },
    onComplete: {
      type: Function,
      default: () => {}
    },
    targetId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      data: []
    }
  },
  mounted () {
    this.setData()
  },
  methods: {
    overwriteFiles () {
      this.$store.dispatch(OVERWRITE_PID, {
        targetId: this.targetId,
        overwrites: this.data
      }).then(res => {
        this.onComplete()
      })
    },
    setData () {
      const overwrites = this.overwrites.map(o => {
        o.title = o.quarter
        o.override = !o.exists
        let year = Number(o.title.split('Q ')[0])
        let quarter = Number(o.title.split('Q ')[1])
        o.number = (year * 100) + quarter
        return o
      })
      this.data = overwrites
    }
  },
  watch: {
    overwrites () {
      this.setData()
    }
  }
}
</script>

<style lang='scss'>
.pid-overwrite-form {
  color: #444444;
  text-align: center;

  &__header {
    margin-bottom: 10px;
  }

  div.table-body {
    overflow-y: hidden;
    width: 75%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// PidOverwriteForm.vue?2aac3c0e